export default "<div style=\"height: 100vh;\"></div>"